module.exports = __webpack_public_path__ + "media/images/emblems/Burgistein-coat_of_arms-429538af112b1a612879673113be6453.svg";